import { useParams, useNavigate } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import Header from "../components/Header"
import { useEffect, useState } from "react";

export default function SubcategoriesPage() {
    const { categoryId } = useParams();
    const navigate = useNavigate();
    const { language } = useLanguage();
    const [data, setData] = useState(null);

    useEffect(() => {
        fetch(`/assets/data.json?_=${Date.now()}`)
            .then(res => res.json())
            .then(setData);
    }, []);

    if (!data) return <div class="text-white font-bold w-full text-align">Loading...</div>;

    const category = data.categories.find(c => c.id === categoryId);

    if (!category || !category.hasSubcategories) return <div>Invalid Category</div>;

    return (
        <>
            <Header />
            {/* Heading + Back Link */}
            <div className="p-4 flex items-center justify-between mt-4">
                <button onClick={() => navigate(-1)} className="text-black px-2 hover:bg-gray-300 relative z-10 bg-white rounded">
                    ← {language === 'en' ? 'Back' : 'Voltar'}
                </button>
                <h1 className="text-3xl font-bold text-white absolute w-full text-center right-0">
                    {category.name[language]}
                </h1>
            </div>
            <ul className='flex flex-wrap flex-row'>
                {category.subcategories.map(sub => (
                    <li className="w-full md:w-6/12 lg:w-4/12 px-2" key={sub.id}>
                        <button className="w-full" onClick={() => navigate(`/menu-categorias/${categoryId}/${sub.id}`)} >
                            <div className="p-5 my-4 border-2 border-b-8 border-[#33525a] rounded-xl">
                                <p className='item-name-heading text-white mb-4 text-5xl'><b>{sub.name[language]}</b></p>
                            </div>
                        </button>
                    </li>
                ))}
            </ul>
        </>
    );
}
